// Global Privacy Control — https://globalprivacycontrol.org/
export function gpcEnabled(): boolean {
  try {
    const n = navigator as Navigator & { globalPrivacyControl?: boolean };
    return n.globalPrivacyControl === true;
  } catch {
    return false;
  }
}
